import { combineReducers } from 'redux';
import { setListUrlReducer, getListReducer } from './vendor_list.reducer';
import indexUrlsReducer from './index_urls.reducer';
import displayReducer from './display.reducer';
import switchesReducer from './switches.reducer';
import {
    setUserConsentReducer,
    setCookieNameReducer,
    expireTimePositiveReducer,
    expireTimeOneNegativeReducer,
    setCookieExpireTimeReducer,
} from './consent.reducer';
import isInitialReducer from './initial.reducer';
import { 
    setCustomPurposesListURLReducer, 
    getCustomPurposesListReducer 
} from './custom_purposes.reducer';
import { translatedListReducer, setLanguageReducer } from './translated_list.reducer';

const rootReducer = combineReducers({
    indexUrls: indexUrlsReducer,
    visible: displayReducer,
    customPurposesListURL: setCustomPurposesListURLReducer,
    customPurposesList: getCustomPurposesListReducer,
    vendorListUrl: setListUrlReducer,
    vendorList: getListReducer,
    consent: setUserConsentReducer,
    cookieName: setCookieNameReducer,
    cookieExpireTime: setCookieExpireTimeReducer,
    expireTimeAllPositive: expireTimePositiveReducer,
    expireTimeOneNegative: expireTimeOneNegativeReducer,
    switches: switchesReducer,
    isInitial: isInitialReducer,
    translatedList: translatedListReducer,
    language: setLanguageReducer,
});

export default rootReducer;